import { render } from "./TypeCoupon.vue?vue&type=template&id=79fb2a0a"
import script from "./TypeCoupon.vue?vue&type=script&lang=js"
export * from "./TypeCoupon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pmerkuloff/Web/hlv/FRONT/hpanel/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__